<div class="flex flex-direction-row footer">
	<div class="flex flex-align-center flex-justify-center" style="padding: 4px">© AMORPH SYSTEMS GMBH {{ cyear }} version: {{ version }}</div>
</div>
